import React from 'react';
import PropTypes from 'prop-types';
import EventSchedule from '~shared/components/react/EventSchedule';
import './styles/oddsBoostWidget.scss';

const BetCardFooter = ({ startTime }) => {
    return (
        <div className='odds-boost-widget__scheduled_date'>
            <EventSchedule startTime={startTime} hideCountdownTimer={true} showDateInline />
        </div>
    );
};

BetCardFooter.propTypes = {
    startTime: PropTypes.string.isRequired,
};

export default BetCardFooter;
